import { render, staticRenderFns } from "./UpgradeToOrgAdminConfirmation.vue?vue&type=template&id=363e8f2e&scoped=true&"
import script from "./UpgradeToOrgAdminConfirmation.vue?vue&type=script&lang=js&"
export * from "./UpgradeToOrgAdminConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeToOrgAdminConfirmation.vue?vue&type=style&index=0&id=363e8f2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e8f2e",
  null
  
)

export default component.exports